import api from "@/libs/axios";
import * as ep from "./endpoints";

export default {
  namespaced: true,
  state: () => ({
    news: [],
    ngoNews: {},
    loading: false,
    loadingNgo: false,
    pagination: {
      total_row: 1,
      per_page: 1,
    },
  }),

  getters: {
    news(state) {
      return state.news;
    },
    ngoNews(state) {
      return state.ngoNews;
    },
    loading(state) {
      return state.loading;
    },
    loadingNgo(state) {
      return state.loadingNgo;
    },
    pagination(state) {
      return state.pagination;
    },
  },

  mutations: {
    setNews(state, payload) {
      state.news = payload;
    },
    setNgoNews(state, payload) {
      state.ngoNews = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
  },

  actions: {
    async getNews(context, { id, page }) {
      context.state.loading = true;
      await api.get(ep.NEWS, { params: { ngo_id: id, page } }).then((res) => {
        context.commit("setNews", res.data.data);
        context.commit("setPagination", res.data.pagination);
        context.state.loading = false;
      });
    },
    async getNgoNews(context, payload) {
      context.state.loadingNgo = true;
      await api.get(ep.NEWS_BY_ID(payload.id)).then((res) => {
        context.commit("setNgoNews", res.data.data);

        context.state.loadingNgo = false;
      });
    },
  },
};
